<template>
    <div class="account-container container-fluid">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <form 
                            action="" 
                            @submit.prevent="updateUser()"
                        >
                            <h5 class="card-title">
                                My Details
                            </h5>
                            <div class="form-group">
                                <label for="name">Full Name</label>
                                <input 
                                    type="text" 
                                    id="name" 
                                    placeholder="Full Name" 
                                    class="form-control" 
                                    v-model="user.name"
                                >
                                <small 
                                    class="form-error" 
                                    v-if="errors.name"
                                >{{ errors.name[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="email">Email Address</label>
                                <input 
                                    type="email" 
                                    id="email" 
                                    placeholder="name@example.com" 
                                    class="form-control" 
                                    v-model="user.email"
                                >
                                <small 
                                    class="form-error" 
                                    v-if="errors.email"
                                >{{ errors.email[0] }}</small>
                            </div>
                            <div>
                                <signature-upload v-model="user.signature_url" />
                                <small
                                    class="form-error"
                                    v-if="errors.order"
                                >{{ errors.signature_url[0] }}</small>
                            </div>
                            <button 
                                type="submit" 
                                class="btn btn-primary"
                            >
                                Save
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <form 
                            action="" 
                            @submit.prevent="changePassword()"
                        >
                            <h5 class="card-title">
                                Change Password
                            </h5>
                            <div class="form-group">
                                <label for="current_password">Current Password</label>
                                <input 
                                    type="password" 
                                    id="current_password" 
                                    placeholder="Current password" 
                                    class="form-control" 
                                    v-model="current_password"
                                >
                                <small 
                                    class="form-error" 
                                    v-if="errors.current_password"
                                >{{ errors.current_password[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="new_password">New Password</label>
                                <input 
                                    type="password" 
                                    id="new_password" 
                                    placeholder="New password" 
                                    class="form-control" 
                                    v-model="new_password"
                                >
                                <small 
                                    class="form-error" 
                                    v-if="errors.new_password"
                                >{{ errors.new_password[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="confirm_password">Confirm Password</label>
                                <input 
                                    type="password" 
                                    id="confirm_password" 
                                    placeholder="Confirm new password" 
                                    class="form-control" 
                                    v-model="confirm_password"
                                >
                                <small 
                                    class="form-error" 
                                    v-if="errors.confirm_password"
                                >{{ errors.confirm_password[0] }}</small>
                            </div>
                            <button 
                                type="submit" 
                                class="btn btn-primary"
                            >
                                Change Password
                            </button>
                        </form>
                    </div>
                </div>
                <div
                    class="card"
                    v-if="user.office_access"
                >
                    <div class="card-body">
                        <h4>Annual Leave & Sickness</h4>
                        <events-list
                            v-if="user.id"
                            :user-id="user.id"
                            ref="eventsList"
                        />
                    </div>
                </div>
            </div>
        </div>
        <b-modal 
            ref="updatedModal" 
            title="Saved" 
            :ok-only="true"
        >
            <p>Account updated</p>
        </b-modal>
        <b-modal 
            ref="passwordModal" 
            title="Password" 
            :ok-only="true"
        >
            <p>Password updated</p>
        </b-modal>
    </div>
</template>
<script>
import SignatureUpload from './SignatureUploadComponent';
import EventsList from './office/admin/users/UserEventsList.vue'
export default {
    components: {
        SignatureUpload,
        EventsList,
    },
    data: function() {
        return {
            user: {},
            current_password: '',
            new_password: '',
            confirm_password: '',
            errors: {}
        };
    },

    mounted: function() {
        window.axios.get("/api/auth/me").then(xhr => {
            this.user = xhr.data;
        });
    },

    methods: {
        updateUser: function() {
            this.errors = {};
            window.axios.post("/api/auth/me", this.user).then(
                xhr => {
                    this.user = xhr.data;
                    this.$refs.updatedModal.show();
                },
                error => {
                    this.errors = error.response.data.errors;
                }
            );
        },

        changePassword: function() {
            this.errors = {};
            const data = {
                current_password: this.current_password,
                new_password: this.new_password,
                confirm_password: this.confirm_password,
            };
            window.axios.post("/api/auth/password", data).then(
                () => {
                    this.$refs.passwordModal.show();
                },
                error => {
                    this.errors = error.response.data.errors;
                }
            );
        },
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MyAccountComponent.vue